<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';

const props = defineProps({
    url: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    },
    layout: {
        type: String, // 'simple' or 'card'
        default: 'card'
    }
});

const page = usePage();
const shareUrl = computed(() => props.url || (typeof window !== 'undefined' ? window.location.href : ''));
const shareTitle = computed(() => props.title || page.props.title || document.title);

const shareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl.value)}`, '_blank', 'width=600,height=400');
};

const shareTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl.value)}&text=${encodeURIComponent(shareTitle.value)}`, '_blank', 'width=600,height=400');
};

const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(shareTitle.value + ' ' + shareUrl.value)}`, '_blank');
};

const notyf = new Notyf({
    duration: 3000,
    position: { x: 'right', y: 'top' },
    ripple: true,
    dismissible: true,
});

const copyLink = async () => {
    // Check if navigator.clipboard is available and context is secure
    if (navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(shareUrl.value);
            notyf.success('Link berhasil disalin!');
        } catch (err) {
            console.error('Clipboard copy failed:', err);
            copyFallback();
        }
    } else {
        copyFallback();
    }
};

const copyFallback = () => {
    try {
        const textArea = document.createElement("textarea");
        textArea.value = shareUrl.value;
        
        // Ensure textarea is not visible but part of DOM
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        textArea.style.top = "0";
        document.body.appendChild(textArea);
        
        textArea.focus();
        textArea.select();
        
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        
        if (successful) {
            notyf.success('Link berhasil disalin!');
        } else {
            notyf.error('Gagal menyalin link.');
        }
    } catch (err) {
        console.error('Fallback copy failed:', err);
        notyf.error('Gagal menyalin link.');
    }
};
</script>

<template>
    <div :class="[
        layout === 'card' ? 'bg-gray-50 border border-gray-200 rounded-xl p-6' : '',
        'w-full'
    ]">
        <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
            <span class="font-bold text-gray-900">Bagikan halaman ini:</span>
            <div class="flex gap-3">
                <button @click="shareFacebook" class="w-10 h-10 rounded-full bg-[#1877F2] text-white flex items-center justify-center hover:scale-110 transition-transform" aria-label="Share to Facebook">
                    <i class="fa fa-facebook"></i>
                </button>
                <button @click="shareTwitter" class="w-10 h-10 rounded-full bg-[#1DA1F2] text-white flex items-center justify-center hover:scale-110 transition-transform" aria-label="Share to Twitter">
                    <i class="fa fa-twitter"></i>
                </button>
                <button @click="shareWhatsApp" class="w-10 h-10 rounded-full bg-[#25D366] text-white flex items-center justify-center hover:scale-110 transition-transform" aria-label="Share to WhatsApp">
                    <i class="fa fa-whatsapp"></i>
                </button>
                <button @click="copyLink" class="w-10 h-10 rounded-full bg-gray-600 text-white flex items-center justify-center hover:scale-110 transition-transform" title="Salin Link" aria-label="Copy Link">
                    <i class="fa fa-link"></i>
                </button>
            </div>
        </div>
    </div>
</template>
